import { render, staticRenderFns } from "./sales-order-shipments-new.vue?vue&type=template&id=664d3a11&"
import script from "./js/sales-order-shipments-new.js?vue&type=script&lang=js&"
export * from "./js/sales-order-shipments-new.js?vue&type=script&lang=js&"
import style0 from "./sales-order-shipments-new.vue?vue&type=style&index=0&id=664d3a11&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports